import { render, staticRenderFns } from "./MutipleChoiceMutipleAnswer.vue?vue&type=template&id=60918001&scoped=true&"
import script from "./MutipleChoiceMutipleAnswer.vue?vue&type=script&lang=js&"
export * from "./MutipleChoiceMutipleAnswer.vue?vue&type=script&lang=js&"
import style0 from "./MutipleChoiceMutipleAnswer.vue?vue&type=style&index=0&id=60918001&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60918001",
  null
  
)

export default component.exports